export default __webpack_public_path__ + "static/media/hero-header.2c66d85a.jpeg";